import { hooks } from "./hookactions"
export let SYSLandingPage01 = { hooks }
